(function () {
  var root = document.documentElement;
  if (root.hasAttribute('data-macaje-qty-keyboard')) return;
  root.setAttribute('data-macaje-qty-keyboard', '');

  document.addEventListener('keydown', function (event) {
    var input = event.target.closest('[data-cart-qty]');
    if (!input || event.key !== 'Enter') return;
    event.preventDefault();
    input.dispatchEvent(new Event('change', { bubbles: true }));
    input.blur();
  });
})();
